import React, { useState } from "react";
import { Button, Radio, Typography, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { connect } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import FilterServices from "../../../services/FilterServices";
import { useMsal } from "@azure/msal-react";
import { getModuleNameBasedOnPath } from "../../../helper/index";

const useStyles = makeStyles((_theme) => ({
  filterKey: {
    color: "#333",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "400",
    lineHeight: "normal",
    flex: 1,
  },
  radio: {
    "& .MuiIconButton-root .MuiSvgIcon-root": {
      width: "14px",
      height: "14px",
      color: "#FF8200",
    },
  },
  icons: {
    margin: "0px 15px",
    cursor: "pointer",
  },
}));

function SavedFilters({
  handleSavedFilterNames,
  handleReset,
  handleClose,
  DC,
  Network,
  Division,
  PL3,
  FilterDate,
  Products,
  selectedSavedFilter,
  selectedID,
  role,
  _tabName,
}) {
  // function SavedFilters({ handleSavedFilterNames,handleReset,handleClose,DC,Network,Division,PL3,Date,Products,selectedSavedFilter,selectedID,role }) {
  let path = window.location.pathname;
  const creatorModule = getModuleNameBasedOnPath(path);
  const classes = useStyles();
  const [filterNameList, setFilterNameList] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  // const { accounts } = useMsal();
  // const activeAccount = accounts[0];
  const handleChangeFilterName = (event) => {
    // savedFilterNameFilterChange(event.target.value);
    setFilterNameList(event.target.value);
  };
  const updateFilters = (params, _instance) => {
    FilterServices.updateFilter(params)
      .then((_data) => {})
      .catch((error) => console.error("Error:", error));
  };
  const savedFilters = (params, _instance) => {
    FilterServices.savedFilters(params)
      .then((_data) => {
        handleReset();
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleSaveFilter = () => {
    handleSavedFilterNames(filterNameList);

    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    const params = {
      filter: {
        RecommendedDC: DC,
        Network: Network,
        PL3: PL3,
        Division: Division,
        Products: Products,
        //  "Date":Date
        Date: FilterDate,
      },
      userId: userDetails?.UserID,
      level: role,
      publicFlag: selectedOption,
      filterName: filterNameList,
      id: selectedID,
      creatorModule: creatorModule,
    };
    if (selectedSavedFilter) {
      updateFilters(params);
    } else {
      savedFilters(params);
    }
  };

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div style={{ padding: "0px 15px" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          sx={{ fontSize: "14px", color: "#222", padding: "10px 0px" }}
        >
          Save Filter
        </Typography>
        <CloseIcon className={classes.icons} onClick={handleClose} />
      </div>

      <TextField
        hiddenLabel
        id="filter-name"
        value={filterNameList}
        variant="outlined"
        placeholder="Type here"
        size="small"
        onChange={handleChangeFilterName}
        sx={{
          width: "330px",
          "& .MuiInputBase-input": {
            height: "15px",
            borderRadius: "4px",
            fontSize: "12px",
            borderColor: "transparent",
            background: "#fff",
            cursor: "pointer",
          },
          "&:focus": {
            backgroundColor: "#FFF",
          },
          "&:hover": {
            backgroundColor: "#FFF",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        }}
      />

      <div
        style={{ display: "flex", padding: "10px 0px", alignItems: "center" }}
      >
        <Button
          variant="contained"
          disabled={!filterNameList || !selectedOption}
          style={{
            borderRadius: "4px",
            backgroundColor:
              !filterNameList || !selectedOption ? "#CCCCCC" : "#2B5692",
            fontSize: "12px",
            textTransform: "none",
          }}
          onClick={handleSaveFilter}
        >
          Save Filter
        </Button>
        <div style={{ marginLeft: "10px" }}>
          <Radio
            value="0"
            name="radio-buttons"
            checked={selectedOption === "0"}
            onChange={handleRadioChange}
            size="small"
            inputProps={{ "aria-label": "Private" }}
            className={classes.radio}
          />
          <span className={classes.filterKey}> Private </span>

          <Radio
            value="1"
            name="radio-buttons"
            checked={selectedOption === "1"}
            onChange={handleRadioChange}
            size="small"
            inputProps={{ "aria-label": "Public" }}
            className={classes.radio}
          />
          <span className={classes.filterKey}> Public </span>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  // Date: state.filter.Date,
  FilterDate: state.filter.Date,
  Division: state.filter.Division,
});

const mapDispatchToProps = (dispatch) => ({
  ApplyFilterActions: (filterData) =>
    dispatch({ type: "APPLY_FILTER", payload: filterData }),
  savedFilterNameFilterChange: (newValue) =>
    dispatch({ type: "FILTER_SAVEDNAMES", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SavedFilters);
